import React from 'react';
import Notification from '../../../models/Notification';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, TableContainer, Typography, Tooltip } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow, ISTableButton, ISTableCell } from '../../Utils/ISTable';
import moment from 'moment';
//import { useThemeContext } from '../../../theme/ThemeContext';
import { useTranslation } from 'react-i18next';
import { SessionState } from '../../../reducers/auth/session';
import { useHistory } from 'react-router-dom';
import { PERSON } from '../../../models/User';
import { roleToURLPrefix } from '../../../App';
import { upsertNotification } from '../../../actions/notification/notificationUpsert';
import { useDispatch } from 'react-redux';
import { DeleteOutlineOutlined } from '@mui/icons-material';
import { fetchNotifications } from '../../../actions/notification/notificationList';


export interface Row {
  data: Notification
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fullInfo?: boolean;
  session?: SessionState;
  onChangePage?: (page: number) => void;
  onClickInfo?: (row: Row, index: number) => void;
}

const Notifications: React.FC<Props> = (props) => {
  //const { theme } = useThemeContext()
  const { t } = useTranslation(['notification', 'login'])
  const history = useHistory()
  const dispatch = useDispatch()

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const otherTooltip = (text: string) => <Paper elevation={2} sx={{ padding: "10px" }}>
    <Typography >{text}</Typography>
  </Paper>


  const readAndOrView = (notification: Notification) => {
    dispatch(upsertNotification({ ...notification, status: 'R' }, () =>
      notification.url && notification.url.includes('http') ? window.open(notification.url!, "_blank", "noopener,noreferrer") : history.push(notification.url)))
  }

  const onClickDelete = (notification: Notification) => {
    dispatch(upsertNotification({ ...notification, status: 'D' }, () =>
      dispatch(fetchNotifications(history.location.search))))
  }


  const rowsToShow = /* !props.fullInfo ? props.rows.slice(0, 5) : */ props.rows

  return (
    <Paper style={{ borderRadius: "10px", margin: "10px", minWidth: "690px", maxWidth: !props.fullInfo ? "710px" : 'inherit' }}>
      <ISTableTitle title={t('lastrecords')} />
      <TableContainer sx={{ overflowX: 'auto', height: !props.fullInfo ? '250px' : '100%' }}>
        <Table style={{ whiteSpace: "nowrap", overflow: "hidden" }} size="medium">
          {props.fullInfo &&
            <TableHead>
              <TableRow selected={true}>
                <ISTableHeaderCell align='center'>{t('date')}</ISTableHeaderCell>
                <ISTableHeaderCell align='center'>{t('time')}</ISTableHeaderCell>
                <ISTableHeaderCell >{t('message')}</ISTableHeaderCell>
                <ISTableHeaderCell >{t('url')}</ISTableHeaderCell>
                <ISTableHeaderCell ></ISTableHeaderCell>
              </TableRow>
            </TableHead>
          }
          <TableBody>
            {!props.loading && props.session && props.session.shouldUpdatePassword &&
              <ISTableRow key='shouldUpdatePassword' color='default'>
                <TableCell style={{ fontWeight: 'bold' }} align='center'>{moment().tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
                {props.fullInfo && <TableCell style={{ fontWeight: 'bold' }} align='center'>{moment().tz("America/Argentina/Buenos_Aires").format('HH:MM')}</TableCell>}
                <TableCell style={{ fontWeight: 'bold', maxWidth: '420px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t('shouldUpdatePassword')}&nbsp;&nbsp;
                </TableCell>
                <TableCell>
                  <ISTableButton text={t('profile', { ns: 'login' })}
                    onClick={() => props.session && history.push(`/${props.session.roles && roleToURLPrefix(props.session.roles.filter(role => role !== PERSON)[0])}/profile`)} />
                </TableCell>
                <ISTableCell></ISTableCell>
              </ISTableRow>
            }
            {!props.loading && rowsToShow.filter(row => !row.data.personId || row.data.personId === props.session?.personId ).map((row, index) => {
              return (
                <ISTableRow key={index} color={mapActionToColor(row.action)}>
                  <TableCell style={{ fontWeight: row.data.status === 'U' ? 'bold' : 'inherit' }} align='center'>{moment(row.data.date).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
                  {props.fullInfo && <TableCell style={{ fontWeight: row.data.status === 'U' ? 'bold' : 'inherit' }} align='center'>{moment(row.data.date).tz("America/Argentina/Buenos_Aires").format('HH:MM')}</TableCell>}
                  {!props.fullInfo &&
                    <ISTableCell tooltip={otherTooltip(row.data.message)}
                      style={{ fontWeight: row.data.status === 'U' ? 'bold' : 'inherit', maxWidth: '420px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {row.data.message}
                    </ISTableCell>}
                  {props.fullInfo &&
                    <Tooltip title={row.data.message}>
                      <TableCell style={{ fontWeight: row.data.status === 'U' ? 'bold' : 'inherit', maxWidth: '420px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.data.message}</TableCell>
                    </Tooltip>}
                  <TableCell style={{ fontWeight: row.data.status === 'U' ? 'bold' : 'inherit' }}>
                    {row.data.url && <ISTableButton text={row.data.url ? t('get') : t('read')} 
                    onClick={(event) => { event.stopPropagation(); readAndOrView(row.data) }} />}
                  </TableCell>
                  <ISTableCell tooltip={otherTooltip(t('delete'))}
                    align='center' sx={{ cursor: 'pointer', lineHeight: "0.5rem", fontSize: "12px" }} onClick={(e) => { e.stopPropagation(); row.data.id && onClickDelete(row.data) }}>
                    <DeleteOutlineOutlined />
                  </ISTableCell>

                </ISTableRow>
              )
            }
            )}
          </TableBody>
        </Table>
        {props.loading &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={25} />
          </div>
        }
        {props.fullInfo && <PaginationButtons pagination={props.pagination} />}
      </TableContainer>
    </Paper>
  );
}

export default Notifications

